import GameCarousel from '~/client/shared/game/GameCarousel';
import CarouselPlaceholder from '~/client/shared/LazyLoad/Placeholder/CaroulselPlaceholder';
import Stack from '~/client/shared/Stack';
import usePlaylistGames from './usePlaylistGames';
import FavouritesSlider from '../FavouritesSlider';

const PlaylistGames: LazyFC = () => {
  const { menuItem, href, game, width, height, theme } = usePlaylistGames();
  const titleBase = `casino.play_other`;

  return (
    <Stack>
      <FavouritesSlider />
      {menuItem && (
        <GameCarousel
          currentPlayingId={game?.id}
          titleId={`${titleBase}.${menuItem}`}
          href={href.menuItem}
          menuItem={menuItem}
          sourcePage="game_page"
          sliderName="play_other"
          placeholder={
            <CarouselPlaceholder
              width={width}
              height={height}
              titleId={`${titleBase}.${menuItem}`}
            />
          }
        />
      )}
      {theme && (
        <GameCarousel
          currentPlayingId={game?.id}
          titleId={`${titleBase}.theme.${theme}`}
          href={href.theme}
          theme={theme}
          sourcePage="game_page"
          sliderName="play_other_theme"
          placeholder={
            <CarouselPlaceholder
              width={width}
              height={height}
              titleId={`${titleBase}.theme.${theme}`}
            />
          }
        />
      )}
    </Stack>
  );
};

export default PlaylistGames;
